import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { caseStudies } from "@/data/caseStudies";

// Asymmetric column spans per project — bento_mode_a
const spans = [
  "md:col-span-8",
  "md:col-span-4",
  "md:col-span-5",
  "md:col-span-7",
  "md:col-span-7",
  "md:col-span-5",
];
const heights = [
  "h-[70vh] md:h-[80vh]",
  "h-[50vh] md:h-[60vh]",
  "h-[55vh] md:h-[65vh]",
  "h-[65vh] md:h-[75vh]",
  "h-[60vh] md:h-[70vh]",
  "h-[55vh] md:h-[65vh]",
];

const WorkCard = ({ project, span, height }) => (
  <Link
    to={`/work/${project.slug}`}
    data-testid={`work-item-${project.slug}`}
    className={`group col-span-12 ${span} block`}
  >
    <div className={`relative overflow-hidden bg-[#EFEEEC] ${height}`}>
      <img
        src={project.cover}
        alt={project.title}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
      <div className="absolute top-5 left-5 right-5 flex items-start justify-between font-mono-mini text-white mix-blend-difference">
        <span>{project.index} / {project.category}</span>
        <span>{project.year}</span>
      </div>
      <div className="absolute bottom-5 right-5 w-10 h-10 border border-white/70 flex items-center justify-center text-white mix-blend-difference opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
        <ArrowUpRight size={18} />
      </div>
    </div>
    <div className="flex items-baseline justify-between mt-4 md:mt-5">
      <h3
        data-testid={`work-title-${project.slug}`}
        className="font-display text-2xl md:text-3xl tracking-tighter text-[#0A0A0A]"
      >
        {project.title}
      </h3>
      <span className="font-mono-mini text-[#8A8A8A]">{project.client}</span>
    </div>
  </Link>
);

export const Works = () => {
  return (
    <section
      id="work"
      data-testid="works-section"
      className="relative py-24 md:py-32 lg:py-40 border-t border-black/10"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <div className="font-mono-mini text-[#8A8A8A]">§ 01</div>
            <div className="font-mono-mini text-[#0A0A0A] mt-1">Selected Work</div>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
              className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[1.05]"
            >
              Two selected case studies. The rest of the archive lives in All
              Projects, each one a search for the quietest version of itself.
            </motion.h2>
          </div>
        </div>

        {/* Asymmetric grid */}
        <div className="grid grid-cols-12 gap-6 md:gap-12">
          {caseStudies.map((p, i) => (
            <WorkCard
              key={p.slug}
              project={p}
              span={spans[i % spans.length]}
              height={heights[i % heights.length]}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
